
/* injects from baggage-loader */

import { getVideoFilterRequest } from "../../sport/videoFilter";
import moment from "moment";
import Config from "../../../config/main";

export const getSwarmSubscriptionRequestSportListStandart = (gameType, timeFilter, videoFilter, isForHashing) => {
    let gameTypeCondition = {
        "live": {"type": 1},
        "prematch": {"@or": [{"type": {"@in": [0, 2]}}, {"visible_in_prematch": 1}]},
        "today": {"@or": [{"start_ts": {'@gte': moment().startOf("day").unix(), '@lte': moment().endOf("day").unix()}, "type": {"@in": [0, 2]}}]}
    };
    let req = {
        "source": "betting",
        "what": {"sport": ["id", "name", "alias", "order"], "game": "@count"},
        "where": {
            "sport": {"type": {"@in": [0, 2, 5]}},
            "game": gameTypeCondition[gameType]
        }
    };
    if (gameType === "topGames") {
        req.where.game = {
            "type": {"@in": [0, 2]},
            "promoted": true
        };
    }
    if (timeFilter === 0 && Config.enableTodayButtonOnSport) {
        let oneDayDate = moment().unix();
        req.where.game = {
            "@or": [{"start_ts": {'@gte': oneDayDate, '@lte': oneDayDate + 86400}, "type": {"@in": [0, 2]}}]
        };
    }
    if (timeFilter) {
        req.where.game.start_ts = {
            '@now': {
                '@gte': Config.enableDayFormatInPrematchLeftMenu ? moment().startOf("day").unix() + (timeFilter * 2) : 0,
                '@lt': Config.enableDayFormatInPrematchLeftMenu ? moment().endOf("day").unix() + timeFilter : timeFilter * 3600
            }
        };
    }
    if (videoFilter && videoFilter !== 'all') {
        req.where.game['@or'] = getVideoFilterRequest();
    }
    return req;
};